import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, stopLoading } from "./commonSlice";
import { getLocalData } from "../constant/utils/commonUtils";
import { supabase } from "../config/supabaseClient";

const mapUpdatesForRpc = (updates) =>
  updates.map((u) => ({
    year_id: u.yearId,
    emp_id: u.empId,
    selected_training_id: u.selectedTrainingId,
    training_type:
      u.trainingType === "Not assigned" ? null : u.trainingType,
    training_category:
      u.trainingCategory === "Not assigned" ? null : u.trainingCategory,
    company_id: u.companyId,
    form_id: u.formId,
    additional_field: u.additionalField ?? {},
  }));

const mapTrainingIdUpdatesForRpc = (trainingIdUpdates) =>
  (trainingIdUpdates || []).map((t) => ({
    selected_training_id: t.selectedTrainingId,
    training_id: t.newTrainingId,
  }));

export const updateTrainingAllocation = createAsyncThunk(
  "bulkTrainingAllocation/updateTrainingAllocation",
  async (
    { updates, trainingIdUpdates = [], comment },
    { rejectWithValue, dispatch }
  ) => {
    try {
      dispatch(startLoading());

      const userData = getLocalData("sdfUser") || getLocalData();

      const { data, error } = await supabase.rpc(
        "bulk_save_allocate_training_with_history",
        {
          p_updates: mapUpdatesForRpc(updates),
          p_training_id_updates: mapTrainingIdUpdatesForRpc(
            trainingIdUpdates
          ),
          p_comment: comment || null,
          p_created_by: userData?.id || null,
        }
      );

      if (error) throw error;

      return {
        success: true,
        updatedCount: updates.length,
        ...data,
      };
    } catch (error) {
      console.error("Error updating bulk training allocation:", error);
      return rejectWithValue(error.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const deleteTrainingAllocation = createAsyncThunk(
  "bulkTrainingAllocation/deleteTrainingAllocation",
  async ({ selectedTrainingId, comment }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoading());

      const userData = getLocalData("sdfUser") || getLocalData();

      const { data, error } = await supabase.rpc(
        "delete_allocate_training_with_history",
        {
          p_selected_training_id: selectedTrainingId,
          p_comment: comment || null,
          p_created_by: userData?.id || null,
        }
      );

      if (error) throw error;

      return { success: true, deletedId: selectedTrainingId, ...data };
    } catch (error) {
      console.error("Error deleting training allocation:", error);
      return rejectWithValue(error.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

const bulkTrainingAllocationSlice = createSlice({
  name: "bulkTrainingAllocation",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearData: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTrainingAllocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTrainingAllocation.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateTrainingAllocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearData } = bulkTrainingAllocationSlice.actions;
export default bulkTrainingAllocationSlice.reducer;
